/**
 * Portal Manta · NovoOrcAdicionarTab
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { BANCO_CHUVA_UF } from '../../data/banco-chuva-uf.js';
import { UFS_BR } from '../../data/ufs-br.js';
import { V, S, fmtNum, fmtBRL } from '../../globals.js';
import { saveKbExtras, THl, TH, TDl, TD } from '../../app-globals.js';

const NovoOrcAdicionarTab = memo(function NovoOrcAdicionarTab_Inner({kbExtras, setKbExtras}){
  const [form, setForm] = useState({
    nome:'', sigla:'', uf:'PR', cidade:'',
    ext:0, dupKm:0, margKm:0, fxKm:0, ciclKm:0,
    oaeQt:0, passQt:0, interQt:0,
    custoTotal:0, custoDup:0, custoMarg:0, custoFx:0, custoCicl:0, custoOae:0, custoPass:0, custoInter:0,
    ctxRural:0.6, ctxUrbano:0.2, ctxSerra:0.2,
    chuvaMM:1500, chuvaDias:110, chuvaRegime:'Regular',
  });
  const setF = (k,v) => setForm(p => ({...p, [k]:v}));
  const onChangeUF = (uf) => {
    const c = BANCO_CHUVA_UF[uf] || {mm:1500,dias:110,regime:'Regular'};
    setForm(p => ({...p, uf, chuvaMM:c.mm, chuvaDias:c.dias, chuvaRegime:c.regime}));
  };

  const salvarExtra = () => {
    if (!form.nome.trim() || !form.sigla.trim()) { window.alert('Preencha NOME e SIGLA.'); return; }
    if (!form.ext || form.ext<=0) { window.alert('Extensão deve ser maior que zero.'); return; }
    const novo = {
      id:'extra-'+Date.now(), nome:form.nome.trim(), sigla:form.sigla.trim().toUpperCase().slice(0,4),
      uf:form.uf, cidade:form.cidade.trim(),
      ext:form.ext, dupKm:form.dupKm, margKm:form.margKm, fxKm:form.fxKm, ciclKm:form.ciclKm,
      oaeQt:form.oaeQt, passQt:form.passQt, interQt:form.interQt, custoTotal:form.custoTotal,
      pu:{
        dup: form.dupKm>0?form.custoDup/form.dupKm:0, marg: form.margKm>0?form.custoMarg/form.margKm:0,
        fx: form.fxKm>0?form.custoFx/form.fxKm:0, cicl: form.ciclKm>0?form.custoCicl/form.ciclKm:0,
        oae: form.oaeQt>0?form.custoOae/form.oaeQt:0, pass: form.passQt>0?form.custoPass/form.passQt:0,
        inter: form.interQt>0?form.custoInter/form.interQt:0,
      },
      ctxRural:form.ctxRural, ctxUrbano:form.ctxUrbano, ctxSerra:form.ctxSerra,
      chuvaMM:form.chuvaMM, chuvaDias:form.chuvaDias, chuvaRegime:form.chuvaRegime,
      addedAt: new Date().toISOString(),
    };
    const atual = [...kbExtras, novo];
    setKbExtras(atual); saveKbExtras(atual);
    setForm({nome:'',sigla:'',uf:'PR',cidade:'',ext:0,dupKm:0,margKm:0,fxKm:0,ciclKm:0,oaeQt:0,passQt:0,interQt:0,custoTotal:0,custoDup:0,custoMarg:0,custoFx:0,custoCicl:0,custoOae:0,custoPass:0,custoInter:0,ctxRural:0.6,ctxUrbano:0.2,ctxSerra:0.2,chuvaMM:1500,chuvaDias:110,chuvaRegime:'Regular'});
    window.alert('Caso "'+novo.nome+'" adicionado à base.\nAgora participa do Wizard (aba A · Estimar).');
  };
  const removerExtra = (id) => {
    if (!window.confirm('Remover este caso?')) return;
    const arr = kbExtras.filter(x=>x.id!==id);
    setKbExtras(arr); saveKbExtras(arr);
  };
  const exportarJSONExtras = () => {
    const blob = new Blob([JSON.stringify(kbExtras, null, 2)], {type:'application/json'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href=url; a.download='manta-kb-extras.json'; a.click();
    URL.revokeObjectURL(url);
  };
  const importarJSONExtras = () => {
    const txt = window.prompt('Cole o JSON exportado anteriormente:', '[]');
    if (!txt) return;
    try {
      const arr = JSON.parse(txt);
      if (!Array.isArray(arr)) throw new Error('JSON deve ser array');
      setKbExtras(arr); saveKbExtras(arr);
      window.alert(arr.length+' casos importados.');
    } catch(e) { window.alert('Erro: '+e.message); }
  };

  const inputStl = {fontSize:11.5,padding:'5px 8px',border:'1px solid '+V.b1,borderRadius:4,outline:'none',width:'100%',fontFamily:'ui-monospace,monospace'};
  const labelStl = {fontSize:9.5,fontWeight:700,color:V.gr,letterSpacing:.3,marginBottom:4,textTransform:'uppercase'};

  return (<div>
    <div style={{...S.cardP,marginBottom:14,padding:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.gn,textTransform:'uppercase',letterSpacing:.05,marginBottom:10}}>1 · Identificação e localização</div>
      <div style={{display:'grid',gridTemplateColumns:'2fr 1fr 1fr 2fr',gap:12}}>
        <div><div style={labelStl}>Nome / descrição</div><input type="text" value={form.nome} onChange={e=>setF('nome',e.target.value)} placeholder="Ex: BR-101 Sul" style={{...inputStl,fontFamily:'inherit'}}/></div>
        <div><div style={labelStl}>Sigla (4 chars)</div><input type="text" value={form.sigla} onChange={e=>setF('sigla',e.target.value)} placeholder="BR101" style={{...inputStl,fontFamily:'inherit',textTransform:'uppercase'}}/></div>
        <div><div style={labelStl}>UF</div>
          <select value={form.uf} onChange={e=>onChangeUF(e.target.value)} style={{...inputStl,padding:'4px 6px',cursor:'pointer',background:'#fff'}}>
            {UFS_BR.map(u => <option key={u} value={u}>{u} · {UF_NOMES[u]}</option>)}
          </select>
        </div>
        <div><div style={labelStl}>Cidade / região</div><input type="text" value={form.cidade} onChange={e=>setF('cidade',e.target.value)} placeholder="Ex: Sul de SC · entre Tubarão e Criciúma" style={{...inputStl,fontFamily:'inherit'}}/></div>
      </div>
    </div>

    <div style={{...S.cardP,marginBottom:14,padding:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.gn,textTransform:'uppercase',letterSpacing:.05,marginBottom:10}}>2 · Quantidades físicas</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))',gap:12,marginBottom:12}}>
        <div><div style={labelStl}>Extensão (km) *</div><input type="number" value={form.ext} onChange={e=>setF('ext',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Duplicações (km)</div><input type="number" value={form.dupKm} onChange={e=>setF('dupKm',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Marginais (km)</div><input type="number" value={form.margKm} onChange={e=>setF('margKm',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Faixas adic. (km)</div><input type="number" value={form.fxKm} onChange={e=>setF('fxKm',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Ciclovias (km)</div><input type="number" value={form.ciclKm} onChange={e=>setF('ciclKm',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>OAEs (un)</div><input type="number" value={form.oaeQt} onChange={e=>setF('oaeQt',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Passarelas (un)</div><input type="number" value={form.passQt} onChange={e=>setF('passQt',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Interseções (un)</div><input type="number" value={form.interQt} onChange={e=>setF('interQt',parseFloat(e.target.value)||0)} style={inputStl}/></div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,padding:'10px 12px',background:V.g0,borderRadius:6,marginBottom:10}}>
        <div><div style={labelStl}>Rural ({(form.ctxRural*100).toFixed(0)}%)</div><input type="range" min="0" max="1" step="0.05" value={form.ctxRural} onChange={e=>setF('ctxRural',parseFloat(e.target.value))} style={{width:'100%'}}/></div>
        <div><div style={labelStl}>Urbano ({(form.ctxUrbano*100).toFixed(0)}%)</div><input type="range" min="0" max="1" step="0.05" value={form.ctxUrbano} onChange={e=>setF('ctxUrbano',parseFloat(e.target.value))} style={{width:'100%'}}/></div>
        <div><div style={labelStl}>Serra ({(form.ctxSerra*100).toFixed(0)}%)</div><input type="range" min="0" max="1" step="0.05" value={form.ctxSerra} onChange={e=>setF('ctxSerra',parseFloat(e.target.value))} style={{width:'100%'}}/></div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
        <div><div style={labelStl}>Chuva (mm/ano)</div><input type="number" value={form.chuvaMM} onChange={e=>setF('chuvaMM',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Dias chuvosos</div><input type="number" value={form.chuvaDias} onChange={e=>setF('chuvaDias',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>Regime</div>
          <select value={form.chuvaRegime} onChange={e=>setF('chuvaRegime',e.target.value)} style={{...inputStl,padding:'4px 6px',cursor:'pointer',background:'#fff'}}>
            <option>Regular</option><option>Sazonal seco</option><option>Sazonal úmido</option><option>Equatorial</option>
          </select>
        </div>
      </div>
    </div>

    <div style={{...S.cardP,marginBottom:14,padding:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.gn,textTransform:'uppercase',letterSpacing:.05,marginBottom:10}}>3 · Custos</div>
      <div style={{marginBottom:12}}><div style={labelStl}>Custo TOTAL (R$)</div><input type="number" value={form.custoTotal} onChange={e=>setF('custoTotal',parseFloat(e.target.value)||0)} style={{...inputStl,fontSize:14,padding:'8px 12px'}}/></div>
      <div style={{fontSize:10,fontWeight:700,color:V.gr,marginBottom:6,letterSpacing:.05}}>DETALHAMENTO POR CATEGORIA (opcional)</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))',gap:12}}>
        <div><div style={labelStl}>R$ Duplicações</div><input type="number" value={form.custoDup} onChange={e=>setF('custoDup',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ Marginais</div><input type="number" value={form.custoMarg} onChange={e=>setF('custoMarg',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ Faixas</div><input type="number" value={form.custoFx} onChange={e=>setF('custoFx',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ Ciclovias</div><input type="number" value={form.custoCicl} onChange={e=>setF('custoCicl',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ OAEs</div><input type="number" value={form.custoOae} onChange={e=>setF('custoOae',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ Passarelas</div><input type="number" value={form.custoPass} onChange={e=>setF('custoPass',parseFloat(e.target.value)||0)} style={inputStl}/></div>
        <div><div style={labelStl}>R$ Interseções</div><input type="number" value={form.custoInter} onChange={e=>setF('custoInter',parseFloat(e.target.value)||0)} style={inputStl}/></div>
      </div>
    </div>

    <div style={{display:'flex',gap:10,marginBottom:20,alignItems:'center'}}>
      <button onClick={salvarExtra} style={{padding:'10px 24px',fontSize:12,fontWeight:800,background:V.gn,color:'#fff',border:'none',borderRadius:6,cursor:'pointer'}}>💾 Adicionar à base</button>
      <span style={{fontSize:9.5,color:V.gr,fontStyle:'italic'}}>Será incluído no Wizard de similaridade (aba A)</span>
    </div>

    <div style={{...S.cardP,padding:14}}>
      <div style={{fontSize:11,fontWeight:800,color:V.br,textTransform:'uppercase',letterSpacing:.05,marginBottom:10,display:'flex',alignItems:'center',gap:8}}>
        <span style={{width:22,height:22,background:V.br,color:'#fff',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:800}}>★</span>
        Extras já salvos · {kbExtras.length}
        <button onClick={exportarJSONExtras} style={{marginLeft:'auto',padding:'4px 10px',fontSize:10,fontWeight:700,border:'1px solid '+V.bl,background:'#fff',color:V.bl,borderRadius:3,cursor:'pointer',textTransform:'none',letterSpacing:0}}>⬇ Exportar JSON</button>
        <button onClick={importarJSONExtras} style={{padding:'4px 10px',fontSize:10,fontWeight:700,border:'1px solid '+V.bl,background:'#fff',color:V.bl,borderRadius:3,cursor:'pointer',textTransform:'none',letterSpacing:0}}>⬆ Importar JSON</button>
      </div>
      {kbExtras.length === 0 ? (
        <div style={{padding:'20px 12px',textAlign:'center',color:V.gr,fontSize:11,fontStyle:'italic'}}>Nenhum caso adicional cadastrado.</div>
      ) : (
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
          <thead><tr style={{borderBottom:'2px solid '+V.b1}}>
            <th style={{...THl,width:60}}>Sigla</th><th style={THl}>Nome</th><th style={{...TH,width:50}}>UF</th><th style={{...TH,width:80}}>Ext (km)</th><th style={{...TH,width:80}}>OAEs</th><th style={{...TH,width:130}}>Custo</th><th style={{...TH,width:50}}></th>
          </tr></thead>
          <tbody>
            {kbExtras.map(e => (
              <tr key={e.id} style={S.trLine}>
                <td style={TDl}><b style={{color:'#7C3AED'}}>{e.sigla}</b></td>
                <td style={TDl}>{e.nome}</td>
                <td style={{...TD,fontSize:9.5,fontWeight:700}}>{e.uf}</td>
                <td style={{...TD,fontFamily:'monospace'}}>{fmtNum(e.ext,1)}</td>
                <td style={{...TD,fontFamily:'monospace'}}>{e.oaeQt}</td>
                <td style={{...TD,fontFamily:'monospace',fontWeight:700,color:V.br}}>{fmtBRL(e.custoTotal,0)}</td>
                <td style={TD}><button onClick={()=>removerExtra(e.id)} style={{padding:'2px 8px',fontSize:11,fontWeight:700,border:'1px solid #ef4444',background:'#fff',color:'#ef4444',borderRadius:3,cursor:'pointer'}}>×</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>);
});

export { NovoOrcAdicionarTab };
export default NovoOrcAdicionarTab;
